import React, {useState} from 'react';
import {Flex, IconButton, useColorModeValue} from '@chakra-ui/react';
import {FaBars} from 'react-icons/fa';
import NavItems from './NavItems';
import UserWidget from './UserWidget';
// import NavItem from '../components/NavItem';

// This is called in the Router.js file
const SideMenu = props => {
  const [navSize, changeNavSize] = useState('small');

  return (
    <Flex
      pos="sticky"
      left="5"
      mx="5"
      boxShadow="0 4px 12px 0 rgba(0, 0, 0, 0.05)"
      borderRadius={navSize == 'small' ? '15px' : '30px'}
      w={navSize == 'small' ? '75px' : '200px'}
      flexDir="column"
      justifyContent="space-between"
      bg={useColorModeValue('tertiary.50', 'gray.700')}
      h="50%"
      display={{base: 'none', md: 'block'}}
    >
      <Flex p="5%" flexDir="column" w="100%" alignItems={navSize == 'small' ? 'center' : 'flex-start'} as="nav">
        <IconButton
          color={'graystone.primary'}
          background="none"
          mt={5}
          _hover={{background: 'none'}}
          icon={<FaBars />}
          onClick={() => {
            if (navSize == 'small') changeNavSize('large');
            else changeNavSize('small');
          }}
        />
        <NavItems screens={props.screens} navSize={navSize} parent={props.parent} />
      </Flex>
      <UserWidget navSize={navSize} />
    </Flex>
  );
};

export default SideMenu;
// https://www.youtube.com/watch?v=U121KdsZ8QE
